var document = require('./_global').document;
module.exports = document && document.documentElement;



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js/library/modules/_html.js
// module id = 57
// module chunks = 0 1